import React from "react";
import styles from "./GetStarted.module.css";

const GetStartedAccount = ({ width = 100, height = 100 }) => {
    return (
        <svg viewBox="0 0 100 100" width={width} height={height}>
            <path
                className={styles.cls1}
                d="M49.67,99.23A49.3,49.3,0,1,1,99,49.94,49.35,49.35,0,0,1,49.67,99.23Zm0-95.55A46.26,46.26,0,1,0,95.93,49.94,46.31,46.31,0,0,0,49.67,3.68Z"
            />
            <path
                className={styles.cls1}
                d="M46.11,44.52A13.38,13.38,0,1,1,59.5,31.14,13.39,13.39,0,0,1,46.11,44.52Zm0-24.8A11.42,11.42,0,1,0,57.53,31.14,11.43,11.43,0,0,0,46.11,19.72Z"
            />
            <path
                className={styles.cls1}
                d="M46.11,45.28A14.14,14.14,0,1,1,60.26,31.14,14.16,14.16,0,0,1,46.11,45.28Zm0-26.76A12.62,12.62,0,1,0,58.74,31.14,12.63,12.63,0,0,0,46.11,18.52Zm0,24.8A12.18,12.18,0,1,1,58.29,31.14,12.19,12.19,0,0,1,46.11,43.32Zm0-22.84A10.66,10.66,0,1,0,56.77,31.14,10.67,10.67,0,0,0,46.11,20.48Z"
            />
            <path
                className={styles.cls1}
                d="M53.68,65H23.6a1,1,0,0,1-1-1A23.56,23.56,0,0,1,34.48,43.59a1,1,0,0,1,1.26.25c.13.16,3.18,3.9,10.37,3.9s10.34-3.86,10.37-3.9a1,1,0,0,1,1.27-.25,23.46,23.46,0,0,1,6.94,6,1,1,0,0,1-1.55,1.21,21.48,21.48,0,0,0-5.7-5.14c-1.33,1.28-4.91,4-11.33,4s-10-2.73-11.32-4A21.59,21.59,0,0,0,24.61,63H53.68a1,1,0,1,1,0,2Z"
            />
            <path
                className={styles.cls1}
                d="M53.68,65.75H23.6A1.74,1.74,0,0,1,21.86,64,24.33,24.33,0,0,1,34.1,42.93a1.74,1.74,0,0,1,2.24.44c.12.15,2.93,3.61,9.77,3.61s9.75-3.57,9.77-3.61a1.75,1.75,0,0,1,2.24-.44,24.36,24.36,0,0,1,7.18,6.23A1.76,1.76,0,0,1,65,51.6,1.67,1.67,0,0,1,63.7,52a1.71,1.71,0,0,1-1.16-.66,20.69,20.69,0,0,0-5-4.64c-1.62,1.4-5.3,3.81-11.41,3.81a17.11,17.11,0,0,1-11.4-3.81,20.76,20.76,0,0,0-9.29,15.62H53.68a1.74,1.74,0,1,1,0,3.48ZM35,44.22a.2.2,0,0,0-.11,0A22.8,22.8,0,0,0,23.38,64a.22.22,0,0,0,.22.22H53.68a.22.22,0,0,0,0-.44H23.81l0-.8A22.29,22.29,0,0,1,34.39,45.05l.5-.32.43.42c1.18,1.14,4.59,3.79,10.79,3.79s9.62-2.65,10.8-3.79l.42-.42.51.32a22.13,22.13,0,0,1,5.9,5.31.23.23,0,0,0,.31,0,.21.21,0,0,0,0-.31,22.65,22.65,0,0,0-6.72-5.84.21.21,0,0,0-.29.06s-3.24,4.19-11,4.19c-7.57,0-10.83-4-11-4.19A.23.23,0,0,0,35,44.22Z"
            />
            <path
                className={styles.cls1}
                d="M68.63,76.68A12.68,12.68,0,1,1,81.3,64,12.69,12.69,0,0,1,68.63,76.68Zm0-23.38A10.71,10.71,0,1,0,79.34,64,10.72,10.72,0,0,0,68.63,53.3Z"
            />
            <path
                className={styles.cls1}
                d="M68.63,77.44A13.44,13.44,0,1,1,82.06,64,13.45,13.45,0,0,1,68.63,77.44Zm0-25.35A11.92,11.92,0,1,0,80.54,64,11.94,11.94,0,0,0,68.63,52.09Zm0,23.39A11.47,11.47,0,1,1,80.1,64,11.48,11.48,0,0,1,68.63,75.48Zm0-21.42a9.95,9.95,0,1,0,10,10A10,10,0,0,0,68.63,54.06Z"
            />
            <path
                className={styles.cls1}
                d="M67,68.93a.94.94,0,0,1-.69-.29L61.67,64a1,1,0,0,1,1.39-1.39l4,4,7.18-7.18a1,1,0,0,1,1.39,1.39l-7.87,7.87A1,1,0,0,1,67,68.93Z"
            />
            <path
                className={styles.cls1}
                d="M67,69.69a1.73,1.73,0,0,1-1.23-.51l-4.64-4.64a1.75,1.75,0,0,1,0-2.47,1.78,1.78,0,0,1,2.46,0L67,65.48l6.65-6.64a1.78,1.78,0,0,1,2.46,0,1.74,1.74,0,0,1,0,2.46l-7.88,7.88A1.76,1.76,0,0,1,67,69.69Zm-4.64-6.6a.23.23,0,0,0-.16.06.26.26,0,0,0,0,.31l4.64,4.64a.23.23,0,0,0,.32,0L75,60.23a.22.22,0,0,0,0-.32.19.19,0,0,0-.31,0L67,67.63l-4.48-4.48A.23.23,0,0,0,62.37,63.09Z"
            />
        </svg>
    );
};

export default GetStartedAccount;
